'use strict';
const _ = require('underscore');
const Backbone = require('backbone');
const ActionHistoryApi = require('process/infra/api/action/history');
const ActionFactory = require('process/domain/factory/action/index');
const ActionRespository = require('process/domain/repository/action/index');

const ActionCollection = Backbone.Collection.extend({
});

class Repository {
    constructor(action) {
        this._action = action;
        this._histories = new ActionCollection();
    }

    add(action) {
        this._histories.add(action, {merge: true});
    }

    on(event, callback) {
        this._histories.on(event, callback);
    }

    get(limit) {
        return new Promise((resolve, reject) => {
            if(this._histories.length > 0) {
                resolve(this._histories);
            } else {
                this.getNext(limit).then(resolve, reject);
            }
        });
    }

    getNext(limit) {
        return new Promise((resolve, reject) => {
            ActionHistoryApi.getNextHistories(
                this._action.getProject().id, this._action.id, limit
            ).then(historiesJson => {
                const factory = new ActionFactory(this._action.getProject());
                const repo = ActionRespository.find(this._action.getProject());
                Promise.all(_.map(historiesJson, h => factory.build(h, repo, true)))
                    .then(histories => {
                        this._histories.add(histories, {merge: true});
                        resolve(this._histories);
                    }, reject);
            }, reject);
        });
    }

    hasNext() {
        return ActionHistoryApi.hasNextHistory(
            this._action.getProject().id, this._action.id);
    }
}

const repositories = {};

const find = function(action) {
    let r = repositories[action.id];
    if (!r) {
        r = new Repository(action);
        repositories[action.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./process/domain/repository/action/history.js